import { watch, type App } from "vue";
import { type UserType } from "@cttq/private-capabilities-v3";
import bfeSensors from "@cttq/bfe-sensors-ts";
import Monitor from "@cttq/cttq-monitor";

export default function VuePluginAbility(app: App, state: { userInfo: UserType }) {
	// 监控
	const { CTTQMonitor } = Monitor;
	CTTQMonitor().init({
		apikey: "CTTQ-SMS-WebPC",
		userInfo: state,
		app
	});
	watch(
		() => { return state.userInfo; },
		(newValue) => {
			// 埋点配置 初始化
			const sensorsConfig = bfeSensors.SensorsConfig.init({
				project: "CTTQ-SMS-WebPC",
				projectName: "供应商中心",
				// 运行环境
				runEnv: import.meta.env.VITE_NODE_ENV,
				// 项目ID
				projectId: "sms-webpc",
				// 人的基础信息,需要从Store中获取
				personInfo: newValue
			});
			sensorsConfig.configSensors();
			app.use(bfeSensors, sensorsConfig);
		}
	);
}
